import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heart, ShoppingBag } from "@phosphor-icons/react";
import { useShop } from "@/context/ShopContext";

export default function ProductCard({ product, index = 0 }) {
  const { t } = useTranslation();
  const { format, addToCart, toggleWishlist, isWishlisted } = useShop();
  const discount = product.compare_at_price ? Math.round(100 - (product.price / product.compare_at_price) * 100) : 0;
  const liked = isWishlisted(product.id);

  return (
    <div className="product-card fade-up group" style={{ animationDelay: `${index * 60}ms` }} data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block relative">
        <div className="zoom-img bg-[#f4f4f4] rounded-2xl overflow-hidden aspect-[4/5] relative">
          <img src={product.images?.[0]} alt={product.name} loading="lazy" className="w-full h-full object-cover" />
          {discount > 0 && (
            <span className="absolute top-3 left-3 bg-white text-[10px] tracking-[0.2em] uppercase font-medium px-2.5 py-1 rounded-full border border-gray-200" data-testid="discount-badge">
              -{discount}%
            </span>
          )}
          {product.is_bestseller && (
            <span className="absolute top-3 right-3 bg-black text-white text-[10px] tracking-[0.2em] uppercase font-medium px-2.5 py-1 rounded-full">Best</span>
          )}
          <button
            onClick={(e)=>{ e.preventDefault(); toggleWishlist(product); }}
            className={`product-overlay absolute bottom-3 right-3 bg-white rounded-full p-2 shadow ${liked?"text-red-500":"text-black"}`}
            data-testid={`wishlist-toggle-${product.slug}`}
            aria-label="wishlist"
          >
            <Heart size={16} weight={liked?"fill":"thin"}/>
          </button>
          <button
            onClick={(e)=>{ e.preventDefault(); addToCart(product); }}
            className="product-overlay absolute bottom-3 left-3 right-12 bg-black text-white text-[11px] tracking-[0.2em] uppercase font-medium py-2.5 rounded-full hover:bg-gold hover:text-black transition-colors flex items-center justify-center gap-1.5"
            data-testid={`quick-add-${product.slug}`}
          >
            <ShoppingBag size={14} weight="thin"/> {t("product.add")}
          </button>
        </div>
      </Link>
      <Link to={`/product/${product.slug}`} className="block mt-4 px-1">
        <h3 className="font-serif-bm text-lg md:text-xl text-[#111] leading-tight line-clamp-2">{product.name}</h3>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-[15px] font-medium">{format(product.price)}</span>
          {product.compare_at_price && <span className="text-xs text-[var(--bm-muted)] line-through">{format(product.compare_at_price)}</span>}
        </div>
      </Link>
    </div>
  );
}
